module.exports = __webpack_public_path__ + "img/首图背景@0.5x.cb4dce5b.png";